export default class Figure extends HTMLElement {
  constructor() {
    super();

    /* Binding */
    this.$paths = this.querySelectorAll('path');
    this.$type = this.dataset.figureType;

    console.log(this.$type);

    this.$paths.forEach((path, index) => {
      if (this.$type === 'reversed') {
        index = this.$paths.length - index - 1;
      }

      path.style.setProperty('--index', index);
    });
  }

  // =============================================================================
  // Lifecycle methods
  // =============================================================================
  connectedCallback() {
    this.bindEvents();
  }

  disconnectedCallback() {
    this.unbindEvents();
  }

  // =============================================================================
  // Events
  // =============================================================================
  bindEvents() {}

  unbindEvents() {}

  // =============================================================================
  // Callbacks
  // =============================================================================

  // =============================================================================
  // Methods
  // =============================================================================
}
